/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProgramList } from '../models/PaginatedProgramList';
import type { Program } from '../models/Program';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReferralsService {

    /**
     * @returns PaginatedProgramList
     * @throws ApiError
     */
    public static referralsProgramsList({
        current = false,
        limit,
        offset,
    }: {
        /**
         * Return the current program
         */
        current?: boolean,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedProgramList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/referrals/programs/',
            query: {
                'current': current,
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * @returns Program
     * @throws ApiError
     */
    public static referralsProgramsRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this program.
         */
        id: string,
    }): CancelablePromise<Program> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/referrals/programs/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
